import {
  Toast,
  ToastTitle,
  useToast as _useToast,
} from "@/components/ui/toast";
import { ComponentPropsWithoutRef, useCallback } from "react";
import { useMobileBreakpoint } from "./useMobileBreakpoint";
import { TOAST_MESSAGE_BUS } from "@/screens/common/toast.consts";

export function useToast() {
  const toast = _useToast();
  const breakpoint = useMobileBreakpoint();

  const showToast = useCallback(
    (
      action: ComponentPropsWithoutRef<typeof Toast>["action"],
      text: string
    ) => {
      const arg: Parameters<typeof toast.show>[0] = {
        placement: breakpoint === "desktop" ? "bottom right" : "bottom",
        render: ({ id }) => {
          return (
            <Toast nativeID={id} variant="solid" action={action}>
              <ToastTitle>{text}</ToastTitle>
            </Toast>
          );
        },
      };

      const result = toast.show(arg);
      if (!result) {
        // context stubbed. use message bus
        TOAST_MESSAGE_BUS.publish("REGULAR", action, text);
      }
    },
    [toast]
  );

  const showError = useCallback(
    (errorOrText?: any) => {
      let text = "Sorry, something went wrong";
      if (typeof errorOrText === "string") {
        text = errorOrText;
      }

      if (
        typeof errorOrText === "object" &&
        (errorOrText.message === "Network request failed" ||
          errorOrText.message === "Failed to fetch")
      ) {
        showToast("error", "Network error. Check internet connection");
      } else {
        showToast("error", text);
      }
    },
    [showToast]
  );

  return {
    showToast,
    showError,
  };
}
